import clsx from 'clsx'
import { FC, useEffect, useState } from 'react'

import { BonusAccruedPanel } from './bonus-accrued-panel/bonus-accrued-panel'

import cls from './transfer-bonus.module.scss'

interface TransferBonusProps {
	bonusCount: number
	isLegal?: boolean
	isLoading?: boolean
}

export const TransferBonus: FC<TransferBonusProps> = ({ bonusCount, isLoading }) => {
	const [rootOpen, setRootOpen] = useState(false)
	useEffect(() => {
		setTimeout(() => setRootOpen(true), 600)
	}, [])

	const rootClasses = clsx(cls.transferBonus, {
		[cls.transferBonus__open]: rootOpen
	})
	return (
		<div className={rootClasses}>
			<BonusAccruedPanel count={bonusCount} isLoading={isLoading} />
		</div>
	)
}
